import FeatureFlag from './FeatureFlag'
import FeatureFlagDisabled from './FeatureFlagDisabled'
import FeatureFlagEnabled from './FeatureFlagEnabled'

export default FeatureFlag
export { FeatureFlagDisabled, FeatureFlagEnabled }
